function onSeriesClick(event, activeElements, chart) {
  const newEvent = { detail: { event, activeElements, chart }, bubbles: true, composed: true };
  /* eslint-disable */
  this.dispatchEvent(new CustomEvent('drilldown', newEvent));
}

/**
 * Currently, if one of series doesn't have hasDrillDown we won't allow the drilldown at all,
 * since in current implementation we can't separate drilldown events by series.
 * @param  {} config
 * @param  {} chartJSConfig
 * @param  {} context
 */
export const registerSeriesClickEvent = (config, chartJSConfig, context) => {
  let isMissingDrilldown = config?.series?.some(singleLine => !singleLine.hasDrillDown);
  if (context.previewMode || isMissingDrilldown) {
    return chartJSConfig;
  }

  chartJSConfig.options.onClick = onSeriesClick.bind(context);
  return chartJSConfig;
};
